import { RoleType } from '@/types/User'

export function hasRole(userRoles: RoleType[], role: RoleType | RoleType[]) {
  if (userRoles.length === 0) {
    return false
  }

  if (Array.isArray(role)) {
    return role.some((r) => userRoles.includes(r))
  }

  return userRoles.includes(role)
}
